import $api from 'http/index';
import { $fetch } from 'http/fetch';
import { getOptions, getKioskOptions } from 'helpers/getOptions';

export const apiCalls = {
  updateTimeOff: async (timeOffId, body) => {
    try {
      const res = await $fetch(`${process.env.REACT_APP_BASE_URL}/timeoffs/${timeOffId}`, {
        ...getOptions(),
        method: 'PUT',
        body: JSON.stringify(body),
      }).then((res) => res.json());
      return res;
    } catch (err) {
      console.log('> ', err);
    }
  },
  removeTimeOff: async (timeOffId) => {
    try {
      const res = await $api.delete(`${process.env.REACT_APP_BASE_URL}/kiosk/timeoffs/${timeOffId}`,
      getKioskOptions())
      return res.data;
    } catch (err) {
      console.log('> ', err);
    }
  },
};
